// extracted by mini-css-extract-plugin
export var emptyState = "_5j-d";
export var statCard = "_5j-c";
export var table = "_5j-0";
export var tableCell = "_5j-4";
export var tableCellClickable = "_5j-5 _5j-4";
export var tableCellDefault = "_5j-6 _5j-4";
export var tableCellEmpty = "_5j-8";
export var tableCellWithValue = "_5j-7";
export var tableContainer = "_5j-e";
export var tableHeaderWeight = "_5j-1";
export var tableHeaderZone = "_5j-2";
export var tableRowHeader = "_5j-3";
export var viewModeButton = "_5j-9";
export var viewModeButtonActive = "_5j-a _5j-9";
export var viewModeButtonInactive = "_5j-b _5j-9";